import _ from 'lodash'
import styled, { css } from 'styled-components'

import { rem, mapProps, mapMarginPaddingProps, toBassNumber } from '../theme'

import Text, { TextBlock, mapTextProps } from './Text'

const SCALE = {
    [-2]: [0.75, 1.25],
    [-1]: [0.875, 1.25],
    [0]: [1, 1.5, 1],
    [1]: [1, 1.75, 1.25],
    [2]: [1.25, 2, 1.5],
    [3]: [1.25, 2, 1.5],
    [4]: [1.75, 2.25, 1.75],
    [5]: [2, 2.5, 2],
}

export const mapParagraphProps = mapProps({
    light: css`color: ${({ theme }) => theme.colors.offblack50};`,
    weight: {
        light: css`
            font-weight: 300;
        `
    },
    width: {
        narrow: css`max-width: 26rem;`,
        normal: css`max-width: 28rem;`,
    },

    scale: _.mapValues(SCALE, ([size, height, margin]) => {
        height = height == null ? size : height

        return css`${''};
            font-size: ${rem(size)};
            line-height: ${({ lineHeight }) => {
                if (lineHeight != null) {
                    return rem(toBassNumber(lineHeight) + height)
                }

                return rem(height)
            }};
            ${margin && css`${''};
                    margin-top: ${rem(margin)};
                    margin-bottom: ${rem(margin)};`};`
    }),

    height(lines, prop, { scale }) {
        let [size, height = size] = SCALE[scale] || SCALE[0];

        return height && css`
            min-height: calc(${lines * height} * 1rem);
        `
    },

    lines(lines, prop, { scale, children }) {
        const words = _.words(children)
        const avg = _.sumBy(words, 'length') / words.length

        const [size] = SCALE[scale] || [1];

        // scale = (scale || 1) * (scaleList[scale] || 1);

        // or 1.5 and 3rem
        return css`
            max-width:
            calc(
                ${_.round(size * (words.length / lines), 2) * (avg > 4.5 ? 1.1 : 1)}
                *
                2.7rem
            );

        `
    },

    color: (color) => css `color: ${color}`
})

export const Paragraph = styled(TextBlock)`
    line-height: ${rem(1.5)};
    font-size: ${rem(1)};

    margin-top: ${rem(1)};
    margin-bottom: ${rem(1)};

    max-width: ${rem(40)};

    ${mapTextProps};
    ${mapParagraphProps};
    ${mapMarginPaddingProps};
`

export default Paragraph



// WEBPACK FOOTER //
// ./src/styleguide/Paragraph.js